import { css } from 'styled-components';
import { Margins } from '../../enums/margin.js';

/**
 * Get Styled Component divider theme
 * @param options GetDividerThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getDividerTheme = (options)=>{
    const { look } = options;
    return css`
    border-top-color: ${({ theme })=>theme.divider[look].borderColor};
  `;
};
/**
 * Get Styled Component divider margins
 * @param options GetDividerMarginOptions
 * @returns ThemedCssFunction<DefaultMargin>
 */ const getDividerMargin = (options)=>{
    const { margin } = options;
    switch(margin){
        case Margins.Large:
            {
                return css`
        margin: 30px 0;
      `;
            }
        case Margins.Medium:
            {
                return css`
        margin: 15px 0;
      `;
            }
        case Margins.None:
            {
                return css`
        margin: 0;
      `;
            }
        case Margins.Small:
            {
                return css`
        margin: 10px 0;
      `;
            }
        default:
            {
                return css``;
            }
    }
};

export { getDividerMargin, getDividerTheme };
//# sourceMappingURL=divider.js.map
